import axios from 'axios';

export default {
  async authenticate(username, password) {
    try {
      return await axios.post('/users/authenticate', {
        username,
        password,
      });
    } catch (error) {
      console.error('authenticate', error);
      throw error;
    }
  },
  async reauthenticate(token) {
    try {
      return await axios.post('/users/reauthenticate', { jwt: token });
    } catch (error) {
      console.error('reauthenticate', error);
      throw error;
    }
  },
  async register(email) {
    try {
      return await axios.post('/payments/registration', { email });
    } catch (error) {
      console.error('register', error);
      throw error;
    }
  },
  async getCurrentUser(uuid) {
    try {
      return await axios.get(`/users/uuid/${uuid}`);
    } catch (error) {
      console.error('getCurrentUser', error);
      throw error;
    }
  },
  // async checkStudentLevels(id) {
  //   try {
  //     return await get(`/students-v2/person/${id}`);
  //   } catch (error) {
  //     console.error('getCurrentUser', error);
  //     throw error;
  //   }
  //   try {
  //     return await axios.get(`/students-v2/person/${id.person.id}`);
  //   } catch (error) {
  //     console.error('getCurrentUser', error);
  //     throw error;
  //   }
  // },
  async getCurrentGrade(id) {
    try {
      return await axios.get(`/students-v2/person/${id}`);
    } catch (error) {
      console.error('getCurrentUser', error);
      throw error;
    }
  },
};
